import { Injectable, inject } from '@angular/core';

import { AdvertisersResponse } from '@rp/shared/models';
import { ADVERTISERS_PROVIDER_TOKEN, AdvertisersProvider } from '@rp/shared/providers';
import { filter, Observable } from 'rxjs';

@Injectable()
export class AdvertisersService implements AdvertisersProvider {
  private readonly _advertisersProvider = inject(ADVERTISERS_PROVIDER_TOKEN);

  getAdvertisers(params?: string): Observable<AdvertisersResponse> {
    return this._advertisersProvider.getAdvertisers(params).pipe(filter(Boolean));
  }
}
